import { Steps } from 'pages/AddPendingVisitPage/AddPendingVisitPage'
import { FiltersSchema } from 'schemas/NewVisitProviderSchema'
import PhoneSchema from 'schemas/PhoneSchema'
import PendingVisit from 'types/visit/pendingVisit'
import * as Yup from 'yup'

export const getStepFromPendingVisit = (pendingVisit: Partial<PendingVisit>, isRescheduling: boolean = false) => {
  const { locationCountry, location, visitType, reasonForVisit, modality, providerId, scheduledAt } = pendingVisit
  const isNowVisit = pendingVisit.scheduledType === 'now'

  if (isRescheduling) {
    return Steps.scheduling
  }

  if (!locationCountry && !location) return Steps.location
  if (!location && locationCountry === 'US') return Steps.locationState
  if (!visitType) return Steps.visitType
  if (!reasonForVisit) return Steps.reason
  if (!modality) return Steps.modality

  if (!isNowVisit) {
    if (!providerId) return Steps.provider
    if (!scheduledAt) return Steps.scheduling
  }

  // Return location as fallback because it is the first step of the scheduling flow.
  return Steps.location
}

export const cleanUrlAfterVisitMapping = (stepValue: number) => {
  const cleanedParams = new URLSearchParams()
  cleanedParams.set('step', String(stepValue))
  const newUrl = `${window.location.pathname}?${cleanedParams.toString()}`
  window.history.replaceState({}, '', newUrl)
}

export const addPendingVisitSchema = Yup.object().shape({
  location: Yup.string().optional().nullable(),
  locationCountry: Yup.string().optional().nullable(),
  visitType: Yup.string().optional().nullable(),
  scheduledType: Yup.string().optional().nullable(),
  price: Yup.number().optional(),
  reasonForVisit: Yup.string().optional().nullable(),
  status: Yup.string().optional().nullable(),
  modality: Yup.string().optional().nullable(),
  phone: Yup.lazy((value) => {
    if (value) {
      return PhoneSchema.required()
    }
    return Yup.mixed().nullable().optional()
  }),
  aslInterpreterNeeded: Yup.boolean().optional(),
  providerId: Yup.string().optional().nullable(),
  providerName: Yup.string().optional().nullable(),
  preferences: Yup.object().nullable().optional(),
  filters: FiltersSchema.optional(),
  providerTimezone: Yup.string().optional().nullable(),
  scheduledAt: Yup.string().optional().nullable(),
})
